/*
 * product-card-sizes — clic en una talla de la tarjeta de producto añade esa
 * variante al carrito mediante `/cart/add.js` y dispara el evento `cart:update`
 * para que el cart drawer e icono del carrito se refresquen (mismo patrón que
 * `upsell-add-button.js`). Event delegation a nivel documento: un solo listener
 * sirve para todas las tarjetas del Home y las páginas de colección.
 *
 * Nota: `e.preventDefault()` + `stopPropagation()` evitan que el <a> que envuelve
 * la tarjeta navegue al PDP cuando el usuario hace clic en una talla.
 */
(function () {
  if (window.__productCardSizesInit) return;
  window.__productCardSizesInit = true;

  function getCartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((el) => el.getAttribute('data-section-id'))
      .filter(Boolean);
  }

  function flashState(btn, className, ms) {
    btn.classList.add(className);
    setTimeout(function () { btn.classList.remove(className); }, ms);
  }

  async function addToCart(btn) {
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.getAttribute('aria-busy') === 'true') return;

    btn.setAttribute('aria-busy', 'true');

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const sectionIds = getCartSectionIds();

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.length ? sectionIds.join(',') : undefined,
        }),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        // El endpoint devuelve { status, message, description } en error.
        console.warn('[product-card-sizes] add failed', data);
        flashState(btn, 'is-error', 1500);
        return;
      }

      // Mismo evento que escucha el cart drawer (ThemeEvents.cartUpdate).
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          source: 'product-card-sizes',
          data: {
            source: 'product-card-sizes',
            itemCount: 1,
            variantId: variantId,
            sections: data.sections,
          },
          resource: data,
        },
      }));

      flashState(btn, 'is-added', 1200);
    } catch (error) {
      console.warn('[product-card-sizes] network error', error);
      flashState(btn, 'is-error', 1500);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  // Captura en fase de captura para ganarle al <a> que envuelve la tarjeta.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest && e.target.closest('[data-product-card-sizes-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  }, true);
})();
